import React, { lazy } from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import LazyLoader from '../components/LazyLoader';
import clients from '../data/clients';
import testimonials from '../data/testimonials';

const Hero = lazy(() => import('../components/home/Hero'));
const Clients = lazy(() => import('../components/home/Clients'));
const Testimonials = lazy(() => import('../components/home/Testimonials'));
const DevelopmentApproach = lazy(() => import('../components/home/DevelopmentApproach'));

const Home = () => {
    const theme = useTheme();
    return (
        <Box sx={{ p: 4, background: theme.palette.background.default }}>
            <LazyLoader>
                <Hero />
            </LazyLoader>
            <LazyLoader>
                <Clients clients={clients} />
            </LazyLoader>
            <LazyLoader>
                <DevelopmentApproach />
            </LazyLoader>
            <LazyLoader>
                <Testimonials testimonials={testimonials} />
            </LazyLoader>
        </Box>
    );
};

export default Home;  